import { createSelector } from 'reselect';

import { getSelectedLocker } from '../..';
import { getAppointmentTaskById } from '../../../../appointmentTask/selectors';

export const getId = createSelector(getSelectedLocker, locker => locker?.nextAppointmentTask);

/**
 * Return the next appointment task
 * @return {Object}
 */
export const get = createSelector(
  state => {
    const id = getId(state);
    return getAppointmentTaskById(state, id);
  },
  appointmentTask => appointmentTask
);
